import React, { useState } from 'react';
import OuterContainer from '../PatientSummary/OuterContainer';
import { ROPatientContextProvider } from '../PatientSummary/context';
import Summary from './components/Summary';

const SummaryPage = (): JSX.Element => {
  return (
    <ROPatientContextProvider>
      <OuterContainer marginBottom="0px" rowSpace="0px">
        <Summary />
      </OuterContainer>
    </ROPatientContextProvider>
  );
};

export default SummaryPage;
